import React, { InputHTMLAttributes, forwardRef } from 'react';

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
    className?: string;
    label?: React.ReactNode;
}

const Input = forwardRef<HTMLInputElement, InputProps>(({ className = '', id, label, prefix, ...props }, ref) => {
    const uniqueId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

    return (
        <div className={`govuk-form-group ${className}`.trim()}>
            {!!label && (
                <label htmlFor={uniqueId} className="govuk-label">
                    {label}
                </label>
            )}

            <input
                ref={ref}
                className="govuk-input"
                id={uniqueId}
                {...props}
            />
        </div>
    );
});

export default Input;
